module.exports = __webpack_public_path__ + "img/manager_register_1.91e6a098.png";